export default "__VITE_ASSET__B8Aw65oy__"